import sdk from '../services/permissions-sdk';
import { endLoading, startLoading } from './app-dux';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    permissions: []
};

/*******************************************************************************
 * Non-async action types
 */
const FETCH_GROUPS = 'FETCH_GROUPS';
const FETCH_GROUP = 'FETCH_GROUP';
const FETCH_APP_PERMISSIONS   = 'FETCH_APP_PERMISSIONS';
const FETCH_USERS   = 'FETCH_USERS';
const CLEAR_STATE   = 'CLEAR_STATE';
const SET_PERMISSIONS = 'SET_PERMISSIONS';

/*******************************************************************************
 * Reducer
 */
export default function permissionsReducer( state = initialState, action ) {
    switch ( action.type ) {
        case FETCH_GROUPS: {
            return {
                ...state,
                groups: action.groups
            };
        }
        case FETCH_GROUP: {
            return {
                ...state,
                group: action.group
            };
        }
        case FETCH_APP_PERMISSIONS: {
            return {
                ...state,
                appPermissions: action.permissions
            };
        }
        case FETCH_USERS: {
            return {
                ...state,
                people: action.users
            };
        }
        case CLEAR_STATE: {
            return {
                ...initialState
            };
        }
        case SET_PERMISSIONS: {
            return {
                ...state,
                permissions: action.permissions
            };
        }
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */

export function getGroup( groupId ) {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.getGroup( groupId )
            .then( ( group )=>{
                dispatch( setGroup( group ) );
                dispatch( endLoading() );
            }
        );
    };
}
export function getOldGroup( groupId ) {

    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.getOldGroup( groupId )
            .then( ( group )=>{

                dispatch( setGroup( group ) );
                dispatch( endLoading() );
            }
        );
    };
}
export function loadAllGroups() {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.getAllGroups()
            .then( ( groups ) => {
                dispatch( setGroups( groups ) );
                dispatch( endLoading() );
            } )
            .catch( error => {
                dispatch( endLoading() );
                return [];
            } );
    };
}
export function saveNewGroup( group ) {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.saveNewGroup( group )
            .then( ( group ) => {
                dispatch( endLoading() );
            } );
    };
}
export function deleteGroup( groupId ) {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.deleteGroup( groupId )
            .then( ( group ) => {
                dispatch( endLoading() );
            } );
    };
}
export function getAppPermissions( ) {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.getAppPermissions()
            .then( ( permissions )=>{
                dispatch( setAppPermissions( permissions ) );
                dispatch( endLoading() );
            } );
    };
}
export function getUsers() {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.getUsers()
        .then( ( users )=> {
            dispatch( setUsers( users ) );
            dispatch( endLoading() );
        } );
    };
}
export function getPermissions() {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.getPermissions()
        .then( ( permissions )=> {
            dispatch( setPermissions( permissions ) );
            dispatch( endLoading() );

        } );
    };
}
export function getPermission( id ) {
    sdk.getPermissions( id )
    .then( ( permissions )=> {
        return permissions.permission;
    } );
}
export function setPermissions( permissions ) {
    return {
        type: SET_PERMISSIONS,
        permissions
    };
}
export function setGroups( groups ) {
    return {
        type: FETCH_GROUPS,
        groups
    };
}
export function setGroup( group ) {
    return {
        type: FETCH_GROUP,
        group
    };
}
export function setUsers( users ) {
    return {
        type: FETCH_USERS,
        users
    };
}
export function setAppPermissions( permissions ) {
    return {
        type: FETCH_APP_PERMISSIONS,
        permissions
    };
}
export function clearState() {
    return {
        type: CLEAR_STATE
    };
}
